<div class="hist-page" *ngIf="!invalidId; else invalidTpl">
  <div class="hist-header d-flex flex-wrap align-items-center justify-content-between mb-3 gap-2">
    <div class="d-flex align-items-center gap-2">
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="goBack()">
        <i class="feather icon-arrow-left"></i> Volver
      </button>
      <div>
        <h5 class="mb-0">Histórico de conectividad</h5>
        <ng-container [ngSwitch]="contextState">
          <small *ngSwitchCase="'loading'" class="text-muted">Cargando institución…</small>
          <small *ngSwitchCase="'ready'" class="text-muted">
            IE {{ context?.institutionName || context?.modularCode || '—' }}
            <span *ngIf="context?.ugel"> · UGEL {{ context?.ugel }}</span>
          </small>
          <small *ngSwitchCase="'error'" class="text-danger">No se pudo cargar la institución.</small>
        </ng-container>
      </div>
    </div>

    <div *ngIf="endpointOptions.length > 1" class="hist-endpoint-selector">
      <label class="form-label small text-muted mb-1">Enlace</label>
      <select
        class="form-select form-select-sm"
        [ngModel]="selectedEndpointKey"
        (ngModelChange)="onEndpointChange($event)"
      >
        <option *ngFor="let opt of endpointOptions" [ngValue]="opt.key">{{ opt.label }}</option>
      </select>
    </div>
  </div>

  <div class="alert alert-danger d-flex justify-content-between align-items-center" *ngIf="contextState === 'error'">
    <span>{{ contextError?.message }}</span>
    <button type="button" class="btn btn-sm btn-outline-danger" (click)="retryContext()">Reintentar</button>
  </div>

  <app-card [hidHeader]="true" cardClass="mb-3" *ngIf="context">
    <div class="row g-3">
      <div class="col-6 col-md-3">
        <div class="hist-field">
          <span class="hist-field__label">Código modular</span>
          <span class="hist-field__value">{{ context.modularCode || '—' }}</span>
        </div>
      </div>
      <div class="col-6 col-md-3">
        <div class="hist-field">
          <span class="hist-field__label">UGEL</span>
          <span class="hist-field__value">{{ context.ugel || '—' }}</span>
        </div>
      </div>
      <div class="col-6 col-md-3">
        <div class="hist-field">
          <span class="hist-field__label">Localidad</span>
          <span class="hist-field__value">{{ localityLabel() }}</span>
        </div>
      </div>
      <div class="col-6 col-md-3">
        <div class="hist-field">
          <span class="hist-field__label">Plan contratado</span>
          <span class="hist-field__value">{{ planLabel() }}</span>
        </div>
      </div>
    </div>
  </app-card>

  <div class="alert alert-info" *ngIf="needsExplicitEndpointSelection">
    Esta institución tiene múltiples enlaces. Selecciona uno para ver su histórico.
  </div>

  <div class="alert alert-warning" *ngIf="hasNoEndpoints">
    No se encontraron enlaces reportados para esta institución.
  </div>

  <ng-container *ngIf="!needsExplicitEndpointSelection && !hasNoEndpoints">
    <app-card [hidHeader]="true" cardClass="mb-3" *ngIf="monthly.state !== 'error'">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <h6 class="mb-0">Resumen mensual</h6>
        <span class="spinner-border spinner-border-sm text-secondary" *ngIf="monthly.state === 'loading'"></span>
      </div>

      <ng-container *ngIf="monthlyKpis; else monthlyEmpty">
        <div class="mb-2">
          <span class="badge bg-light text-dark">{{ monthlyKpis.periodLabel }}</span>
        </div>
        <p class="text-muted small mb-3" *ngIf="monthlyKpis.isVolumePartial">
          Hay información disponible solo para una parte del período.
        </p>
        <div class="row g-3 hist-kpis">
          <div class="col-6 col-md">
            <div class="hist-kpi">
              <span class="hist-kpi__label"><i class="feather icon-arrow-down"></i> Bajada acumulada</span>
              <span class="hist-kpi__value">{{ formatVolume(monthlyKpis.downloadBytes) }}</span>
            </div>
          </div>
          <div class="col-6 col-md">
            <div class="hist-kpi">
              <span class="hist-kpi__label"><i class="feather icon-arrow-up"></i> Subida acumulada</span>
              <span class="hist-kpi__value">{{ formatVolume(monthlyKpis.uploadBytes) }}</span>
            </div>
          </div>
          <div class="col-6 col-md">
            <div class="hist-kpi">
              <span class="hist-kpi__label">Total transferido</span>
              <span class="hist-kpi__value">{{ formatVolume(monthlyKpis.totalBytes) }}</span>
            </div>
          </div>
          <div class="col-6 col-md">
            <div class="hist-kpi">
              <span class="hist-kpi__label"><i class="feather icon-trending-up"></i> Pico</span>
              <span class="hist-kpi__value hist-kpi__peak">
                <span class="hist-peak hist-peak--down">↓ {{ formatPeakMbps(monthlyKpis.downloadMaxMbps) }}</span>
                <span class="hist-peak__sep">·</span>
                <span class="hist-peak hist-peak--up">↑ {{ formatPeakMbps(monthlyKpis.uploadMaxMbps) }}</span>
              </span>
            </div>
          </div>
          <div class="col-6 col-md">
            <div class="hist-kpi">
              <span class="hist-kpi__label">Disponibilidad</span>
              <span class="hist-kpi__value">{{ availability.percent }}<small>%</small></span>
              <span class="hist-kpi__hint">{{ availability.caption }}</span>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #monthlyEmpty>
        <p class="text-muted small mb-0" *ngIf="monthly.state === 'ready'">
          No hay datos disponibles para este período.
        </p>
      </ng-template>
    </app-card>

    <div
      class="alert alert-danger d-flex justify-content-between align-items-center mb-3"
      *ngIf="monthly.state === 'error'"
    >
      <span>{{ monthly.error?.message }}</span>
      <button
        type="button"
        class="btn btn-sm btn-outline-danger"
        *ngIf="monthly.error?.retryable"
        (click)="retryMonthly()"
      >
        Reintentar
      </button>
    </div>

    <div class="row g-3">
      <div class="col-12">
        <app-card [hidHeader]="true">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <div class="d-flex align-items-center gap-2">
              <h6 class="mb-0">Uso de Internet — últimas 24 horas</h6>
              <span class="hist-partial-chip" *ngIf="last24hIsPartial">Información parcial</span>
            </div>
            <span class="spinner-border spinner-border-sm text-secondary" *ngIf="last24h.state === 'loading'"></span>
          </div>

          <div
            class="alert alert-danger d-flex justify-content-between align-items-center mb-0"
            *ngIf="last24h.state === 'error'"
          >
            <span>{{ last24h.error?.message }}</span>
            <button
              type="button"
              class="btn btn-sm btn-outline-danger"
              *ngIf="last24h.error?.retryable"
              (click)="retryLast24h()"
            >
              Reintentar
            </button>
          </div>

          <ng-container *ngIf="last24h.state === 'ready'">
            <p class="text-muted small mb-0" *ngIf="last24h.data?.dataStatus === 'NO_CURRENT_TRAFFIC_REFERENCES'">
              No hay referencias de tráfico actuales para este enlace.
            </p>
            <p class="text-muted small mb-0" *ngIf="last24h.data?.dataStatus === 'NO_DATA'">
              No hay datos disponibles para este período.
            </p>
            <ng-container *ngIf="last24hChart && last24h.data?.dataStatus !== 'NO_DATA' && last24h.data?.dataStatus !== 'NO_CURRENT_TRAFFIC_REFERENCES'">
              <apx-chart
                [series]="last24hChart.series!"
                [chart]="last24hChart.chart!"
                [xaxis]="last24hChart.xaxis!"
                [yaxis]="last24hChart.yaxis!"
                [stroke]="last24hChart.stroke!"
                [dataLabels]="last24hChart.dataLabels!"
                [colors]="last24hChart.colors!"
                [legend]="last24hChart.legend!"
                [tooltip]="last24hChart.tooltip!"
                [grid]="last24hChart.grid!"
                [fill]="last24hChart.fill!"
                [annotations]="last24hChart.annotations!"
              ></apx-chart>
            </ng-container>
          </ng-container>
        </app-card>
      </div>

      <div class="col-12">
        <app-card [hidHeader]="true">
          <div class="d-flex flex-wrap align-items-center justify-content-between mb-2 gap-2">
            <h6 class="mb-0">Uso diario</h6>
            <div class="d-flex flex-wrap align-items-center gap-2">
              <div class="btn-group btn-group-sm" role="group" aria-label="Métrica diaria">
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  [class.active]="dailyMetricMode === 'avg'"
                  (click)="setDailyMetricMode('avg')"
                >
                  Promedio
                </button>
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  [class.active]="dailyMetricMode === 'p95'"
                  (click)="setDailyMetricMode('p95')"
                >
                  Uso alto
                </button>
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  [class.active]="dailyMetricMode === 'max'"
                  (click)="setDailyMetricMode('max')"
                >
                  Pico
                </button>
              </div>
              <div class="btn-group btn-group-sm" role="group" aria-label="Rango diario">
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  [class.active]="dailyRangeMode === 7"
                  (click)="setDailyRange(7)"
                >
                  7d
                </button>
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  [class.active]="dailyRangeMode === 30"
                  (click)="setDailyRange(30)"
                >
                  30d
                </button>
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  [class.active]="dailyRangeMode === 90"
                  (click)="setDailyRange(90)"
                >
                  90d
                </button>
              </div>
            </div>
          </div>

          <span class="spinner-border spinner-border-sm text-secondary" *ngIf="daily.state === 'loading'"></span>

          <div
            class="alert alert-danger d-flex justify-content-between align-items-center mb-0"
            *ngIf="daily.state === 'error'"
          >
            <span>{{ daily.error?.message }}</span>
            <button
              type="button"
              class="btn btn-sm btn-outline-danger"
              *ngIf="daily.error?.retryable"
              (click)="retryDaily()"
            >
              Reintentar
            </button>
          </div>

          <ng-container *ngIf="daily.state === 'ready'">
            <p class="text-muted small mb-0" *ngIf="daily.data?.dataStatus === 'NO_DATA'">
              No hay datos disponibles para este período.
            </p>
            <p class="text-muted small mb-2" *ngIf="daily.data?.dataStatus === 'PARTIAL'">
              Hay información disponible solo para una parte del período.
            </p>
            <apx-chart
              *ngIf="dailyChart && daily.data?.dataStatus !== 'NO_DATA'"
              [series]="dailyChart.series!"
              [chart]="dailyChart.chart!"
              [xaxis]="dailyChart.xaxis!"
              [yaxis]="dailyChart.yaxis!"
              [stroke]="dailyChart.stroke!"
              [dataLabels]="dailyChart.dataLabels!"
              [colors]="dailyChart.colors!"
              [legend]="dailyChart.legend!"
              [tooltip]="dailyChart.tooltip!"
              [grid]="dailyChart.grid!"
            ></apx-chart>
          </ng-container>
        </app-card>
      </div>

      <div class="col-12">
        <app-card [hidHeader]="true">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <h6 class="mb-0">Datos transferidos por mes</h6>
            <span class="spinner-border spinner-border-sm text-secondary" *ngIf="monthly.state === 'loading'"></span>
          </div>
          <p class="text-muted small mb-2" *ngIf="monthlyPartialHint">
            Hay información disponible solo para una parte del período.
          </p>
          <ng-container *ngIf="monthly.state === 'ready'">
            <apx-chart
              *ngIf="monthlyChart"
              [series]="monthlyChart.series!"
              [chart]="monthlyChart.chart!"
              [xaxis]="monthlyChart.xaxis!"
              [yaxis]="monthlyChart.yaxis!"
              [stroke]="monthlyChart.stroke!"
              [dataLabels]="monthlyChart.dataLabels!"
              [colors]="monthlyChart.colors!"
              [legend]="monthlyChart.legend!"
              [tooltip]="monthlyChart.tooltip!"
              [grid]="monthlyChart.grid!"
              [plotOptions]="monthlyChart.plotOptions!"
            ></apx-chart>
          </ng-container>
        </app-card>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #invalidTpl>
  <div class="alert alert-danger">
    Identificador de institución inválido.
    <button type="button" class="btn btn-sm btn-outline-danger ms-2" (click)="goBack()">Volver</button>
  </div>
</ng-template>
